import { createRouter, createWebHashHistory } from 'vue-router';
import Home from './pages/Home.vue';
import Login from '@lib/frontend/pages/Login.vue';
import Ocean from './components/Ocean.vue';
import Editocean from './components/Editocean.vue';
import Calender from './components/Calender.vue';
import Oceancalender from './components/Oceancalender.vue';
import Calculation from './Calculation/Calculation.vue';
import ServiceList from './Calculation/ServiceList.vue';
import TourList from './Calculation/TourList.vue';
import Audit from './Calculation/Audit.vue';
import TourDetails from './Calculation/TourDetails.vue';
import City from './Calculation/City.vue';
import Tours from './Calculation/Tours.vue';
import Tourstats from './Calculation/Tourstats.vue';
import AnalyticsDashboard from '../src/AnalyticsDashboard/AnalyticsDashboard.vue';



import CalculationRiver from './CalculationRiver/CalculationRiver.vue';
import ServiceListRiver from './CalculationRiver/ServiceListRiver.vue';
import TourListRiver from './CalculationRiver/TourListRiver.vue';
import AuditRiver from './CalculationRiver/AuditRiver.vue';
import TourDetailsRiver from './CalculationRiver/TourDetailsRiver.vue';
import PrizeWheel from './components/PrizeWheel.vue';

import CalculationLondon from './CalculationLondon/CalculationLondon.vue';
import ServiceListLondon from './CalculationLondon/ServiceListLondon.vue';
import TourListLondon from './CalculationLondon/TourListLondon.vue';
import AuditLondon from './CalculationLondon/AuditLondon.vue';
import TourDetailsLondon from './CalculationLondon/TourDetailsLondon.vue';
import CityLondon from './CalculationLondon/CityLondon.vue';
import ToursLondon from './CalculationLondon/ToursLondon.vue';
import TourstatsLondon from './CalculationLondon/TourstatsLondon.vue';




const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/allotments',
    name: 'Ocean',
    component: Ocean
  },

  {
    path: '/ocean/edit/:id',
    name: 'Editocean',
    component: Editocean
  },

  {
    path: '/calender',
    name: 'Calender',
    component: Calender
  },

  {
    path: '/LFO',
    name: 'LFO_Prize_Wheel',
    component: PrizeWheel
  },

  {
    path: '/oceancalender',
    name: 'Oceancalender',
    component: Oceancalender
  },
  {
    path: '/calculation',
    name: 'Calculation',
    component: Calculation,
    children: [
      {
        path: 'tourlist',
        components: { default: TourList }
      },
      {
        path: 'itemlist',
        components: { default: ServiceList }
      },
      {
        path: 'audit',
        components: { default: Audit }
      },
      {
        path: 'city',
        component: City
      },
      {
        path: 'tourstats',
        component: Tours
      },
      {
        path: 'analytics',
        component: AnalyticsDashboard
      },

    ]
  },
  {
    path: '/tour-details/:tourCode',
    name: 'Tourstats',
    component: Tourstats,
    props: true
  },

  {
    path: '/tour/:id',
    name: 'TourDetails',
    component: TourDetails,
    props: true
  },
  {
    path: '/calculation-river',
    name: 'CalculationRiver',
    component: CalculationRiver,
    children: [
      {
        path: 'tourlistriver',
        components: { default: TourListRiver }
      },
      {
        path: 'itemlistriver',
        components: { default: ServiceListRiver }
      },
      {
        path: 'auditriver',
        components: { default: AuditRiver }
      },
      {
        path: 'city',
        component: City
      }

    ]
  },
  {
    path: '/tourriver/:id',
    name: 'TourDetailsriver',
    component: TourDetailsRiver,
    props: true
  },
  {
    path: '/calculation-london',
    name: 'CalculationLondon',
    component: CalculationLondon,
    children: [
      {
        path: 'tourlist',
        components: { default: TourListLondon }
      },
      {
        path: 'itemlist',
        components: { default: ServiceListLondon }
      },
      {
        path: 'audit',
        components: { default: AuditLondon }
      },
      {
        path: 'city',
        component: CityLondon
      },
      {
        path: 'tourstats',
        component: ToursLondon
      },
    ]
  },
  {
    path: '/tour-details-london/:tourCode',
    name: 'TourstatsLondon',
    component: TourstatsLondon,
    props: true
  },
  {
    path: '/tour-london/:id',
    name: 'TourDetailsLondon',
    component: TourDetailsLondon,
    props: true
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});

export default router;
